module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hamburger"
  }, [_c('div', {
    staticClass: "menu-btn",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('div', {
    staticClass: "menu-global menu-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-global menu-middle"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-global menu-bottom"
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-20c1135f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20c1135f","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hamburger.vue
// module id = 393
// module chunks = 0